var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[_c('img',{staticClass:"mb10",attrs:{"src":require("@/assets/noData.png"),"alt":""}}),_c('div',{staticClass:"c9"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }